import { useEffect, useRef, useCallback } from 'react'

const INACTIVITY_TIMEOUT_MS = 900000 // 15 minut

const ACTIVITY_EVENTS: (keyof WindowEventMap)[] = [
  'mousemove',
  'keydown',
  'mousedown',
  'touchstart',
  'scroll',
]

/**
 * useInactivityTimeout — po 15 minutach bezczynności wywołuje onLock().
 * Nie zarządza sam stanem blokady — deleguje to do useBiometricAuth.
 */
export function useInactivityTimeout(onLock: () => void, enabled: boolean) {
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null)
  const onLockRef = useRef(onLock)
  onLockRef.current = onLock

  const resetTimer = useCallback(() => {
    if (timerRef.current) clearTimeout(timerRef.current)
    timerRef.current = setTimeout(() => {
      onLockRef.current()
    }, INACTIVITY_TIMEOUT_MS)
  }, [])

  useEffect(() => {
    if (!enabled) {
      if (timerRef.current) clearTimeout(timerRef.current)
      return
    }

    resetTimer()

    const handleActivity = () => resetTimer()

    ACTIVITY_EVENTS.forEach(evt =>
      window.addEventListener(evt, handleActivity, { passive: true })
    )

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current)
      ACTIVITY_EVENTS.forEach(evt =>
        window.removeEventListener(evt, handleActivity)
      )
    }
  }, [enabled, resetTimer])
}
